import {faCheck, faEye, faFileSignature, faSpinner, faStopwatch, faUserCheck} from "@fortawesome/free-solid-svg-icons";
import React from "react";
import FasesAcontecimento from "../../../components/FasesAcontecimento";

export function fases(acontecimento) {
  return <FasesAcontecimento acontecimento={acontecimento} fases={[
    {
      field: "data_ativacao",
      descripion: ["Publicado", "Publicado"],
      icon: faEye
    },
    {
      field: "data_abertura_registos",
      descripion: ["Abertura de candidaturas", "Candidaturas abertas"],
      icon: faFileSignature
    },
    {
      field: "data_limite_registos",
      descripion: ["Limite para candidaturas", "Candidaturas fechadas"],
      icon: faStopwatch
    },
    {
      field: "data_registos_fechados",
      descripion: ["Seleção de candidaturas", "Participantes selecionados"],
      icon: faUserCheck
    },
    {
      field: "data_inicio_curso",
      descripion: ["Início do curso", "Curso a decorrer"],
      icon: faSpinner
    },
    {
      field: "data_fecho",
      descripion: ["Fim do curso", "Curso terminado"],
      icon: faCheck
    }
  ]}/>
}